import {FC, KeyboardEvent, useState} from 'react'
import {MultiValue} from 'react-select'
import CreatableSelect from 'react-select/creatable'
import {Option} from '../../../types/models'

type Props = {
  value: string[]
  onChange: (numbers: string[]) => void
  isAgent: boolean
}

export const InternalNumbersInput: FC<Props> = ({value, onChange, isAgent}) => {
  const [inputValue, setInputValue] = useState('')

  if (!isAgent) {
    return (
      <input
        type='text'
        className='form-control form-control-solid'
        placeholder='внутренний номер'
        value={value[0] ?? ''}
        onChange={(e) => onChange(e.target.value ? [e.target.value] : [])}
      />
    )
  }

  const isOwnNumber = (number: string) => number === value[0]

  const addPending = () => {
    const pending = inputValue
      .split(/[\s,;]+/)
      .map((n) => n.trim())
      .filter((n) => n && !value.includes(n))
    if (pending.length) onChange([...value, ...Array.from(new Set(pending))])
    setInputValue('')
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if (!inputValue) return
    if (['Enter', 'Tab', ',', ' ', ';'].includes(e.key)) {
      e.preventDefault()
      addPending()
    }
  }

  return (
    <CreatableSelect<Option<string>, true>
      isMulti
      isClearable={false}
      menuIsOpen={false}
      components={{DropdownIndicator: null}}
      className='react-select-multi-custom react-select-solid'
      classNamePrefix='react-select'
      classNames={{
        multiValue: ({data}) => (isOwnNumber(data.value) ? 'bg-light-primary' : ''),
        multiValueLabel: ({data}) => (isOwnNumber(data.value) ? 'text-primary fw-bold' : ''),
      }}
      placeholder='внутренние номера'
      inputValue={inputValue}
      onInputChange={(v) => setInputValue(v)}
      onKeyDown={handleKeyDown}
      onBlur={addPending}
      value={value.map((n) => ({label: n, value: n}))}
      onChange={(v: MultiValue<Option<string>>) => onChange(v.map((o) => o.value))}
    />
  )
}
